import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/*
 * Smooth-scrolls to the #anchor in the URL (e.g. arriving at /#contact from a
 * detail page or footer link). global.css already sets scroll-behavior: smooth,
 * and respects prefers-reduced-motion.
 */
export default function useHashScroll() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    // Wait a tick so the target section is mounted.
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ block: 'start' });
    }, 0);
    return () => clearTimeout(t);
  }, [hash, pathname]);
}
